import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
//import { BarChart } from '@mui/x-charts/BarChart';
import {Home} from '@mui/icons-material';
import {APIProvider, Map, AdvancedMarker, Marker, Pin} from '@vis.gl/react-google-maps';


export class MapCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      context: this.props.context ? this.props.context : 'tratamento',
      dataini: this.props.dataini ? this.props.dataini : new Date().toISOString().substring(0, 10),
      datafim: this.props.datafim ? this.props.datafim : new Date().toISOString().substring(0, 10),
      sexo: this.props.sexo ? this.props.sexo : [1],
      idade: this.props.idade ? this.props.idade : [18,100],
      procedimento: this.props.procedimento ? this.props.procedimento : [1],
      doutor: this.props.doutor ? this.props.doutor : [1],
      title: '---',
      markers: [],
      //Credentials - Início: https://console.cloud.google.com/project/_/google/maps-apis/credentials?utm_source=Docs_RestrictAPIKey&utm_content=Docs_maps-backend&_gl=1*1ej0513*_ga*MTk5NzExNjgzOS4xNzQ4MTA2OTY1*_ga_NRWSTWS78N*czE3NDgxODI0MDkkbzMkZzEkdDE3NDgxODI5MjgkajAkbDAkaDA.
      map_api_key: 'AIzaSyB_WwYj9ufkKkGhnXv7XkEpL4rf4bweqQU',
      map_id: 'ab3ac0a712ba6f5c50f05023',
      //Credentials - Fim
    };
  }
  
  
  componentDidMount = () => {
    this.updateData();
  }; 
  
  
  
  updateStates = (dataini, datafim, sexo, idade, procedimento, doutor) => {
    this.setState({ dataini: dataini, datafim: datafim, sexo: sexo, idade: idade, procedimento: procedimento, doutor: doutor }, () => {this.updateData()} );
  }
  
  
  
  
  updateData = () => {
    if(this.state.context === 'tratamento'){
      this.setState({ loading: true });
      this.props.api
        .get('/Dashboard/PatientLatLong/' + this.state.dataini + '/' + this.state.datafim + '/' + this.state.sexo + '/' + this.state.idade + '/' + this.state.procedimento + '/' + this.state.doutor )
        .then((r) => {
          var retValues = this.parseStats(r);
          
          this.setState({
            title: 'Distribuição Geográfica',
            markers: retValues,
            loading: false,
          });             
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    } 
    

    
    
      
  }; 
  
  
  
  parseStats(r){
    //console.log(r.data);
    var colors = ["rgb(255, 80, 80)", "rgb(51, 102, 255)", "rgb(102, 255, 51)", "rgb(204, 0, 204)", "rgb(0, 204, 204)", "rgb(204, 204, 0)", "rgb(255, 153, 0)", "rgb(255, 153, 255)", "rgb(153, 102, 0)", "rgb(51, 102, 0)", "rgb(0, 51, 153)", "rgb(0, 255, 153)", "rgb(255, 102, 153)", "rgb(102, 102, 153)", "rgb(255, 204, 204)", "rgb(153, 51, 51)", "rgb(204, 204, 255)"];
    
    var pincolors = {}      
    var data = []
    var index = 0;
    
    for(let [key,value] of Object.entries(r.data)){
      if(!(value["treatment"] in pincolors)){
        index = Object.keys(pincolors).length;
        pincolors[value["treatment"]] = colors[index];
      }      
      data.push([ value["treatment"]+" - "+value["patient_id"],pincolors[value["treatment"]],value["lat"],value["long"] ])
    }
            
    return(data);
  }
  
  

    
  
  
  
  render() {
    const colorPalette = ['#0059b3', '#027af2', '#99ccff','#0059b3', '#027af2', '#99ccff','#0059b3', '#027af2', '#99ccff','#0059b3', '#027af2', '#99ccff','#0059b3', '#027af2', '#99ccff'];
  
    return (
    <Card variant="outlined" sx={{ width: '100%' }}>
      <CardContent>
        <Typography component="h2" variant="subtitle2" gutterBottom>{this.state.title}</Typography>
        {/*ver https://visgl.github.io/react-google-maps/ */}
        <APIProvider apiKey={this.state.map_api_key}>
          <Map
            style={{width: '100vw', height: '100vh'}}
            defaultCenter={{lat: -22.798118574304574, lng: -43.270648075101505}}
            defaultZoom={11}
            gestureHandling={'greedy'}
            disableDefaultUI={false}
            mapId={this.state.map_id}
          >
            {/* MGM position*/}
            <AdvancedMarker 
              position={{lat: -22.965548978609654, lng: -43.17703775065943}} 
              title={'Clínica MGM'}
            >
              <Pin background={"rgb(132, 113, 107)"} glyphColor={'#fff'} borderColor={'#000'} >
                <span className="icon"><Home /></span>
              </Pin>           
            </AdvancedMarker>
            
            {/* Others */}
            <>
              {this.state.markers.map(function(item) {
                return (
                  <AdvancedMarker 
                    position={{lat: item[2], lng: item[3]}} 
                    title={item[0]}
                  >
                    <Pin background={item[1]} glyphColor={'#fff'} borderColor={'#000'} />
                  </AdvancedMarker>
                )
              })}
            </>
            
          </Map>
        </APIProvider>  
      </CardContent>
    </Card>
    
    
    );
  }
}























